import { render, staticRenderFns } from "./TestForm.vue?vue&type=template&id=a64f7156&scoped=true"
import script from "./TestForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TestForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TestForm.vue?vue&type=style&index=0&id=a64f7156&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64f7156",
  null
  
)

export default component.exports